import { FormEvent } from "react"
import { Head, useForm, usePage } from "@inertiajs/react"
import { AccountShell } from "@/components/AccountShell"
import { PageHeader } from "@/components/PageHeader"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import type { PageProps } from "@/types/inertia"

export default function SupportShow() {
  const { props } = usePage<PageProps>()
  const form = useForm({ subject: "", message: "" })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post("/account/support", {
      preserveScroll: true,
      onSuccess: () => form.reset(),
    })
  }

  return (
    <>
      <Head title="Support">
        <meta name="description" content="Get help with Flywrite — send us a support request." />
        <meta property="og:title" content="Support" />
        <meta property="og:description" content="Get help with Flywrite — send us a support request." />
      </Head>
      <AccountShell>
        <PageHeader
          title="Support"
          description="Stuck on something? Send a message and we'll reply by email — usually within a business day."
        />

        <form onSubmit={submit} className="mt-8 max-w-xl space-y-4">
          <div className="space-y-2">
            <label htmlFor="subject">Subject</label>
            <Input
              id="subject"
              value={form.data.subject}
              onChange={(e) => form.setData("subject", e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="message">How can we help?</label>
            <textarea
              id="message"
              className="form-control form-control-textarea"
              rows={6}
              required
              value={form.data.message}
              aria-invalid={!!props.errors?.message}
              onChange={(e) => form.setData("message", e.target.value)}
            />
            {props.errors?.message && (
              <p className="text-xs text-danger-display">{props.errors.message}</p>
            )}
          </div>
          <Button type="submit" disabled={form.processing}>
            Send message
          </Button>
        </form>
      </AccountShell>
    </>
  )
}
